module.exports = __webpack_public_path__ + "static/media/anc6ru.6e41fe9b.pdf";